type GoogleTextSource = {
  origin?: string;
  googleEventId?: string | null;
  notes?: string | null;
  description?: string | null;
  rawGoogleDescription?: string | null;
};

const HTML_ENTITY_MAP: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
};

export function decodeHtmlEntities(value: string): string {
  return String(value || "")
    .replace(/&#(\d+);/g, (_, code: string) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, code: string) => String.fromCharCode(parseInt(code, 16)))
    .replace(/&([a-zA-Z]+);/g, (_, name: string) => HTML_ENTITY_MAP[name.toLowerCase()] ?? `&${name};`);
}

export function stripHtmlTags(value: string): string {
  const source = String(value || "");
  const withoutNonContentBlocks = source
    .replace(/<\s*(script|style|head|meta|title|link|noscript)\b[\s\S]*?<\s*\/\s*\1\s*>/gi, "")
    .replace(/<\s*meta\b[^>]*>/gi, "")
    .replace(/<\s*link\b[^>]*>/gi, "")
    .replace(/<\s*body\b[^>]*>/gi, "")
    .replace(/<\s*\/\s*body\s*>/gi, "")
    .replace(/<\s*html\b[^>]*>/gi, "")
    .replace(/<\s*\/\s*html\s*>/gi, "");

  const withBreaks = withoutNonContentBlocks
    .replace(/<\s*br\s*\/?\s*>/gi, "\n")
    .replace(/<\s*\/\s*p\s*>/gi, "\n")
    .replace(/<\s*p\b[^>]*>/gi, "")
    .replace(/<\s*\/\s*div\s*>/gi, "\n")
    .replace(/<\s*div\b[^>]*>/gi, "")
    .replace(/<\s*\/\s*li\s*>/gi, "\n")
    .replace(/<\s*li\b[^>]*>/gi, "- ")
    .replace(/<\s*\/\s*tr\s*>/gi, "\n")
    .replace(/<\s*\/\s*t[dh]\s*>/gi, "\t")
    .replace(/<[^>]+>/g, "");

  return decodeHtmlEntities(withBreaks)
    .replace(/\r\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .trim();
}

export function cleanGoogleCalendarDescription(value: unknown): string {
  return stripHtmlTags(String(value ?? ""));
}

export function getAppointmentDisplayNotes(event: GoogleTextSource): string {
  const raw = event.origin === "google" || Boolean(event.googleEventId)
    ? (event.notes || event.description || event.rawGoogleDescription || "")
    : (event.notes || event.description || "");
  return cleanGoogleCalendarDescription(raw);
}
